module.exports = __webpack_public_path__ + "static/media/miah.833b78bc.jpg";